<script setup lang="ts">
import vPreloadImg from '@/ts/directives/v-preload-img.ts';
import { globalBlurLogic } from '@/ts/management/ui-management.ts';
import model from '@/ts/model.ts';
import type { AstronautImgPosition } from '@/ts/types/astronaut-img-types.ts';
import { computed } from 'vue';

const props = defineProps<{index?: number, img?: string, position?: AstronautImgPosition, mobilePosition?: AstronautImgPosition, offset?: number, mobileOffset?: number}>();
const astronautImages: Record<string, string> = import.meta.glob('@/assets/astronauts/astr*.*', {eager: true, import: 'default', query: '?url'});

function getImg(){
    if(props.img) return props.img;

    const targetKeys = Object.keys(astronautImages).filter(key => key.includes(props.index + ''));
    if(!targetKeys.length) return;

    const res: Record<string, string> = {};
    targetKeys.forEach(key => {
        const targetVal = astronautImages[key];
        if(targetVal) res[key] = targetVal;
    });

    return res;
}

const imgOffset = computed<string>(() => {
    if(model.isMobile && props.mobileOffset) return `translateY(${props.mobileOffset}px)`;
    if(props.offset) return `translateY(${props.offset}px)`;
    return '';
})
</script>

<template>
    <template v-if="model.siteKey == 'fund'">
        <div class="astronaut-img" :style="{transform: imgOffset}" :class="{blur: globalBlurLogic}">
            <img v-preload-img="getImg()" :data-position="model.isMobile ? (mobilePosition || position) : position" v-mobile>
        </div>
    </template>
</template>

<style lang="scss" scoped>
    @use '@/scss/shared';
    .astronaut-img{
        position: relative;
        pointer-events: none;
        z-index: 30;
        max-width: shared.$max-resolution;
        margin: 0 auto;
        & > img{
            position: absolute;
            z-index: inherit;
            &[data-mobile]{
                height: 150px;
            }
            &[data-position="left"]{
                transform: translateY(-50%);
                left: 0;
            }
            &[data-position="right"]{
                transform: translateY(-70%);
                right: 0;
            }
            &[data-position="center"]{
                transform: translateX(-50%) translateY(-50%);
                left: 50%;
            }
        }
    }
</style>